import { useTheme, useMediaQuery, Accordion, AccordionSummary, AccordionDetails, Box, Typography, Link} from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import OtherReportsTable from './OtherReportsTable';

interface Props {
    lateContributionSummary: string;
    
}

const StatePartyCommittee = (props: Props): JSX.Element => {
    const theme = useTheme();
    const isSM = useMediaQuery(theme.breakpoints.down('sm'));

    return (

        <Box>
            <Typography variant="h6" gutterBottom fontWeight={600}>
                State Party Committee
            </Typography>
            <Typography variant="body1" component={'p'} gutterBottom>
                The state committees of political parties organized under M.G.L. chapter 52, section 1.
            </Typography>
            <Typography variant="body1" component={'p'} gutterBottom marginTop={2}>
                Click <Link underline="none" href="https://www.ocpfreporter.us/Account/Register" target="_blank">here</Link> to register with OCPF .
            </Typography>

            <Accordion defaultExpanded>
                <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                    <Typography fontWeight={'bold'} variant={'subtitle1'}>Current Filing Schedule</Typography>
                </AccordionSummary>
                <AccordionDetails>
                    <OtherReportsTable isStateParty={true} lateContributionSummary={props.lateContributionSummary} />
                </AccordionDetails>
            </Accordion>

          
        </Box>
    )
};

export default StatePartyCommittee;